import React, { useState, useEffect, useRef } from 'react';
import '../../assets/css/CustomSlider.css';
import SliderAdminPanel from '../../assets/img/slider_admin_panel.png';
import SliderMonitoring from '../../assets/img/slider_monitoring.png';
import SliderControl from '../../assets/img/slider_control.png';

const CustomSlider = () => {

    const [activeIndex, setActiveIndex] = useState(0);
    const [direction, setDirection] = useState("next");
    const [isPlaying, setIsPlaying] = useState(true);
    const [isAnimating, setIsAnimating] = useState(false);
    const [enteringIndex, setEnteringIndex] = useState(null);
    const [enteringActive, setEnteringActive] = useState(false);
    const intervalRef = useRef(null);

    const slides = [
        {
            img: SliderAdminPanel,
            titleLine1: "Bienvenido al Panel de Administración",
            titleLine2: "Gestión Eficiente",
            description: "Supervisa y administra laboratorios, usuarios y registros con herramientas avanzadas para la toma de decisiones."
        },
        {
            img: SliderMonitoring,
            titleLine1: "Monitoreo en Tiempo Real",
            titleLine2: "Estadísticas Globales",
            description: "Visualiza el rendimiento de la red de laboratorios y el estado de los municipios conectados."
        },
        {
            img: SliderControl,
            titleLine1: "Control Total",
            titleLine2: "Seguridad y Accesibilidad",
            description: "Administra permisos y accesos para garantizar la integridad de los datos en toda la plataforma."
        }
    ];

    useEffect(() => {
        if (isPlaying) startInterval();
        else stopInterval();
        return () => stopInterval();
    }, [isPlaying, activeIndex]);

    const startInterval = () => {
        stopInterval();
        intervalRef.current = setInterval(() => {
            triggerSlide("next");
        }, 5000);
    };

    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const triggerSlide = (dir, targetIndex = null) => {
        if (isAnimating) return;

        const nextIdx = targetIndex !== null
            ? targetIndex
            : dir === "next"
                ? (activeIndex + 1) % slides.length
                : (activeIndex - 1 + slides.length) % slides.length;

        if (nextIdx === activeIndex) return;

        setIsAnimating(true);
        setDirection(dir);
        setEnteringIndex(nextIdx);
        setEnteringActive(false);

        // Doble requestAnimationFrame: el browser registra la posición
        // inicial antes de activar la transición
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setEnteringActive(true);
            });
        });

        setTimeout(() => {
            setActiveIndex(nextIdx);
            setEnteringIndex(null);
            setEnteringActive(false);
            setIsAnimating(false);
        }, 650);
    };

    const nextSlide = () => triggerSlide("next");
    const prevSlide = () => triggerSlide("prev");

    const goToSlide = (index) => {
        if (index === activeIndex) return;
        const dir = index > activeIndex ? "next" : "prev";
        triggerSlide(dir, index);
    };

    const togglePlay = () => setIsPlaying(!isPlaying);

    const getItemClass = (idx) => {
        if (enteringIndex === null) {
            return idx === activeIndex ? "slide-active" : "slide-hidden";
        }
        if (idx === activeIndex) {
            return direction === "next" ? "slide-exit-left" : "slide-exit-right";
        }
        if (idx === enteringIndex) {
            const enterClass = direction === "next" ? "slide-enter-right" : "slide-enter-left";
            return enteringActive ? `${enterClass} slide-entering` : enterClass;
        }
        return "slide-hidden";
    };

    return (
        <div className="custom-slider-container">

            <div id="dashboardSlider" className="carousel slide">

                {/* Indicators */}
                <div className="carousel-indicators">
                    {slides.map((_, idx) => (
                        <button
                            key={idx}
                            type="button"
                            onClick={() => goToSlide(idx)}
                            className={idx === activeIndex ? "active" : ""}
                            aria-current={idx === activeIndex}
                        ></button>
                    ))}
                </div>

                {/* Slides */}
                <div className="carousel-inner">
                    {slides.map((slide, idx) => (
                        <div
                            key={idx}
                            className={`carousel-item custom-carousel-item ${getItemClass(idx)}`}
                        >
                            <img
                                src={slide.img}
                                alt={slide.titleLine2}
                                className="slider-hd-image"
                            />
                            <div className="carousel-overlay">
                                <div className="carousel-caption-custom">
                                    <h4>{slide.titleLine1}</h4>
                                    <h2>{slide.titleLine2}</h2>
                                    <p>{slide.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Control Anterior "<" */}
                <button
                    className="carousel-control-prev"
                    type="button"
                    onClick={prevSlide}
                    aria-label="Anterior"
                >
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                </button>

                {/* Control Siguiente ">" */}
                <button
                    className="carousel-control-next"
                    type="button"
                    onClick={nextSlide}
                    aria-label="Siguiente"
                >
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                </button>

                {/* Play / Pause */}
                <div className="slider-controls">
                    <button
                        className="btn-play-pause"
                        onClick={togglePlay}
                        aria-label={isPlaying ? "Pausar" : "Reproducir"}
                    >
                        {isPlaying
                            ? <i className="bi bi-pause-fill"></i>
                            : <i className="bi bi-play-fill"></i>
                        }
                    </button>
                </div>

            </div>

        </div>
    );
};

export default CustomSlider;